import {Component, Input, OnInit} from '@angular/core';
import {PluginConnectService} from "../../../../shared/services/plugin-connect/plugin-connect.service";
import {CONNECT_AND_OPTIMIZE_POINTS} from "./connect-and-optimize-points";

@Component({
    selector: 'db-connect-and-optimize',
    templateUrl: './connect-and-optimize.component.html',
    styleUrls: ['./connect-and-optimize.component.scss'],
    standalone: false
})
export class ConnectAndOptimizeComponent implements OnInit {
  @Input() email: string;
  public websiteUrl = '';
  public points = CONNECT_AND_OPTIMIZE_POINTS;

  constructor(
    private readonly _pluginConnectService: PluginConnectService,
  ) {
  }

  ngOnInit() {
    this.websiteUrl = this._pluginConnectService.pluginData  ? this._pluginConnectService.pluginData.siteUrl : '';
  }

  connect(): void {
    this._pluginConnectService.connect(this.email);
  }
}
